<script setup>
import { toRefs } from 'vue'
import { RollbackOutlined } from '@ant-design/icons-vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'

const props = defineProps({
  hasForm: {
    type: Boolean,
    default: false
  },
  returnPath: {
    type: String,
    default: ''
  }
})

const { hasForm, returnPath } = toRefs(props)

const goBack = async () => {
  if (hasForm.value) {
    const isConfirm = await mySwal.confirm({
      title: '表單尚未送出，是否確定離開？',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
      customClass: {
        confirmButton: 'btn m-[0.3125em] bg-scp-royal-blue text-white text-lg hover:bg-blue-800',
        cancelButton: 'btn m-[0.3125em] text-lg btn-ghost'
      },
      buttonsStyling: false
    })

    if (isConfirm) {
      window.location.href = returnPath.value
    }
  } else {
    window.location.href = returnPath.value
  }
}
</script>
<template>
  <div class="flex justify-end gap-3 py-3">
    <button @click="goBack" type="button" class="btn btn-ghost text-xl">
      <RollbackOutlined />
      返回
    </button>
  </div>
</template>
